import { Col, Container, Row } from 'react-bootstrap';
import './contest.css';

const Contest = () => {
  return (
    <Container fluid className='contest__main__container'>
      <Container>
        <Row>
          <Col>
            <h1 className='contest__h1'> CONTEST </h1>

            <h3 className='contest__h3'>
              There will be a competition for the owner of nft in which you
              could win $10,000 in ETH!
            </h3>
            {/* <h4 className='contest__h4'>
              So what do you have to do to participate?
              </h4>
            <p className='contest__p'>Is simple:</p> */}
            <p className='contest__p__box'>Own a Kutee Kitty!</p>
            <p className='contest__p__box'>
            Make a film while helping the environment by:<br></br>
Collect plastic from the street and throw it in the trash<br></br>
Collect litter on the beach or in any natural location<br></br>
Create like works of art with unused plastic<br></br>
And all the things you think could help our planet
            </p>
            <p className='contest__p__box'>
              10 winners will be chosen at the end of the contest, and the top
              reward is a $10,000 in ETH!
            </p>
            <h3 className='contest__p'>
              This contest is only limited to NFT holders for the first phase;
              after that, it will be open to everyone because our objective is
              to build a global community that can help to preserve the planet
              as a whole!
            </h3>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Contest;
